import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { resource }: Boundaries["editResourceWeeklyCalendar"]["request"],
): State {
  const index = state.findIndex((req) => req.resource.uuid === resource.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { request: setRequestStateToPending(), resource },
        ...state.slice(index + 1),
      ]
    : [...state, { request: setRequestStateToPending(), resource }];
}

function handleSuccess(
  state: State,
  { resource }: Boundaries["editResourceWeeklyCalendar"]["success"],
): State {
  const index = state.findIndex((req) => req.resource.uuid === resource.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { request: setRequestStateToSuccess(), resource },
        ...state.slice(index + 1),
      ]
    : [...state, { request: setRequestStateToSuccess(), resource }];
}

function handleFailure(
  state: State,
  { resource }: Boundaries["editResourceWeeklyCalendar"]["failure"],
): State {
  const index = state.findIndex((req) => req.resource.uuid === resource.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { request: setRequestStateToFailure(), resource },
        ...state.slice(index + 1),
      ]
    : [...state, { request: setRequestStateToFailure(), resource }];
}

const reduceState = createStateReducer(initialState, {
  [events.editResourceWeeklyCalendarRequested]: handleRequest,
  [events.editResourceWeeklyCalendarSucceeded]: handleSuccess,
  [events.editResourceWeeklyCalendarFailed]: handleFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
